import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { ListComponent } from './list/list.component';
import { ListItemComponent } from './list-item/list-item.component';

@NgModule({
  imports: [MaterialModule, FormsModule, CommonModule],
  declarations: [ListComponent, ListItemComponent],
  exports: [ListComponent, ListItemComponent],
})
export class ListModule {}
